export default __webpack_public_path__ + "static/media/alignTop.6a3ca622.svg";